import "antd/dist/antd.css";
import React, { useRef } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import useSWR from "swr";
import Api from "../../../../../../initialpage/hooks/Api";
import { API } from "../../../../StoreComponents/conflict";
import NotFoundPage from "../../../../StoreComponents/NotFoundPage";
import { imageApi } from "../../../../../../initialpage/hooks/HrApi";
const fetcher = (url) => API.get(url).then((res) => res.data.data);
const ViewAllowedProduct = () => {
  const { empId } = useParams();
  const { data: dataSource, error: error2 } = useSWR(
    empId ? `store/permission/users/${empId}` : null,
    fetcher
  );

  console.log(dataSource);
  const navigate = useNavigate();

  // print
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  return (
    <>
      <Helmet>
        <title>Profile - BBA Store</title>
        <meta name="description" content="Profile - BBA Store" />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important} "
        }
      </style>
      <div className="page-wrapper">
        {!dataSource ? (
          <NotFoundPage></NotFoundPage>
        ) : (
          <div className="content container-fluid main-container">
            <div className="d-flex align-items-center justify-content-between mb-4 search-div_store">
              <h3 className="text-start text-dark">
                View Not Allowed Products
              </h3>
              <div>
                <button
                  type="button"
                  className="btn btn-color_store px-3"
                  onClick={handlePrint}
                >
                  <i className="fa fa-print"></i>
                  <span> Print</span>
                </button>

                <button
                  onClick={() => navigate(-1)}
                  class="btn btn-o px-3 ms-1"
                  style={{
                    background: "#000",
                    color: "#fff",
                    borderRadius: "10px",
                  }}
                >
                  <i class="fa fa-hand-o-left"></i> Back
                </button>
              </div>
            </div>

            {/* Product By Category */}

            <div ref={componentRef}>
              <div className="text-center my-5">
                <h5>
                    <b>INFOTECH IT SOLUTIONS</b>
                </h5>
               
              </div>
              <div className="mt-5  d-flex justify-content-center">
                <div className="w-50">
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th colSpan={12} className="text-center">
                          Not Allow Product List
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td colSpan={6}>Photo</td>
                        <td colSpan={6}>
                          <img
                            style={{ height: "70px", width: "70px" }}
                            src={`${imageApi}${dataSource?.employee.PHOTO_PATH}`}
                            alt=""
                          />
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={6}>Name</td>
                        <td colSpan={6}>{dataSource?.employee.NAME_ENGLISH}</td>
                      </tr>
                      <tr>
                        <td colSpan={6}>Designation</td>
                        <td colSpan={6}>{dataSource?.employee.DESIGNATION}</td>
                      </tr>
                      <tr>
                        <td colSpan={6}>Department</td>
                        <td colSpan={6}>{dataSource?.employee.DEPARTEMENT}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row mt-5 px-5">
                <div className="col-12">
                  <div id="printArea" className="table-responsive">
                    <table className="table table-bordered table-striped ">
                      <thead>
                        <tr>
                          <th>S/N</th>
                          <th>Product Name</th>
                          <th>Category</th>
                        </tr>
                      </thead>

                      {dataSource.accessProducts && (
                        <tbody>
                          {dataSource.accessProducts.map((product, index) => (
                            <tr key={index}>
                              <th>{index + 1}</th>
                              <td>
                                {product.PRONAME} <br />
                                {product.PRONAMETWO}
                              </td>
                              <td>
                                {" "}
                                {product.CATEGORYEN} <br />
                                {product.CATEGORYBN}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ViewAllowedProduct;
